import { isPageBackgroundMask } from './pageBackground';

// Le décor de page n'a jamais de couleur de fond : il est posé par-dessus le
// contenu, un fond opaque le recouvrirait en entier — il ne resterait que ses
// traits, le filigrane et le pied de page. Le réglage n'est plus proposé sur le
// décor, mais d'anciens documents en portent un : le masque s'appelait « fond
// de page » quand un fond blanc s'y posait sous le contenu.
//
// Vaut pour le décor du document comme pour ceux bakés depuis les sections
// (cf. isPageBackgroundMask).
//
// La règle est posée sur les données plutôt que sur l'affichage : à la lecture
// (formatResContent, qui couvre l'éditeur, l'aperçu et le service PDF) et à
// l'écriture (updateMask). Un document ancien se corrige tout seul, et aucun
// chemin ne peut redonner un fond au décor.
//
// Le fond est ôté de la copie en mémoire, pas de la base : il l'est à chaque
// chargement, elle n'a donc pas besoin d'être nettoyée.
//
// Les autres masques (couverture, séparateurs, page vierge...) gardent le leur.

export const hasPageBackgroundFill = (mask) =>
  isPageBackgroundMask(mask) && mask.backgroundColor !== undefined;

export const withoutPageBackgroundFill = (mask) => {
  if (!hasPageBackgroundFill(mask)) return mask;
  const { backgroundColor, ...rest } = mask;
  return rest;
};
